import { SystemStyleObject } from "@chakra-ui/react";

export const accordionItemTriggerCss: SystemStyleObject = {
  display: "flex",
  alignItems: "center",
  padding: "16px 0",
};

export const defaultAccordionItemBodyCss: SystemStyleObject = {
  paddingTop: "0",
};
